import { PayloadAction } from "@reduxjs/toolkit";
import { IExecuteCompatibilityCalculationPayload } from "../../types/cloudFunctions";
import { call, put, takeEvery } from "redux-saga/effects";
import { calculateCompatibilityError, calculateCompatibilitySuccess } from "./slice";
import { callCloudFunction } from "../../service/common/firebase";
import { EXECUTE_COMPATIBILITY_CALCULATION_CLOUD_FUNCTION } from "../../constants/cloudFunctions";
import { CALCULATE_COMPATIBILITY_ACTION } from "./actions";
import { toast } from "react-toastify";

function* calculateCompatibility({
  payload: calculationData
}: PayloadAction<IExecuteCompatibilityCalculationPayload>): any {
  try {
    const calculationRes = yield call(callCloudFunction, EXECUTE_COMPATIBILITY_CALCULATION_CLOUD_FUNCTION, calculationData);
    console.log('CF RES', calculationRes);
    if ((calculationRes.data as any).outcome) {
      yield put(calculateCompatibilitySuccess((calculationRes.data as any).data));
    } else {
      throw (calculationRes.data as any).error
    }
  } catch (error) {
    if ((error as any).code === 'A001') {
      toast.error('Abbonamento non valido');
    }
    yield put(calculateCompatibilityError(error));
  }
}

export default function* interviewSaga() {
  yield takeEvery(CALCULATE_COMPATIBILITY_ACTION, calculateCompatibility);
}